export default function SvgOneImage3() {
  return (
    <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45px"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4 10V6a2 2 0 012-2h6M4.027 18.329A2 2 0 006 20h12a2 2 0 002-2v-3.81M4.027 18.33A2.014 2.014 0 014 18v-3m.027 3.329l3.82-3.82a2 2 0 012.427-.16l.51.34a2 2 0 002.358-.103l2.648-2.118a2 2 0 012.333-.12c.08.052.15.115.217.182L20 14.19m0 0V6a2 2 0 00-2-2h-1m-6 5a2 2 0 11-4 0 2 2 0 014 0z"
      ></path>
    </svg>
    </>
  );
}
